import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';
import { LineInterface } from '../../../../lines/models/line.interface';
import { PriceDetailsInterface } from '../../../models/price-details.interface';

@Component({
  selector: 'app-three-way-conference',
  templateUrl: './three-way-conference.component.html',
  styleUrls: ['./three-way-conference.component.css'],
  standalone: false
})
export class ThreeWayConferenceComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  active: boolean;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.active = this.line.optionsStatus.three_way_conference;
    this.formSubmitted = false;
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new SaveMission({
        step: 1,
        active: !this.active,
        phoneNumber: this.line.phoneNumber
      }, this.procedureCode));
    }
  }
}
